import styled from 'styled-components';

export const Wrapper = styled.div<{ $showLeft: boolean; $showRight: boolean }>`
	position: relative;
	width: 100%;
`;
